export default "__VITE_ASSET__C6DwO1nc__"